/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import SidebarQuery, {
	type JsmProjectMenuWrapper_SidebarQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jsm-project-menu/src/ui/project-menu/__generated__/JsmProjectMenuWrapper_SidebarQuery.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const getQuery: Parameters<
	typeof createRelayResource<JsmProjectMenuWrapper_SidebarQuery>
>[0]['getQuery'] = ({ match, query }, resourceContext) => {
	const cloudId = resourceContext?.tenantContext?.cloudId ?? '';
	let { projectKey } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters: SidebarQuery,
		variables: {
			cloudId,
			projectKey,
			isRenamingEnabled: fg('jsm_project_nav_rename_hr'),
		},
	};
};

export const jsmProjectMenuContentSidebarResource: RouteResource<
	PreloadedQuery<JsmProjectMenuWrapper_SidebarQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<JsmProjectMenuWrapper_SidebarQuery>({
		type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
		getQuery,
	}),
);
